import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "UsersManagementPageBlock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActAccessTable = _resolveComponent("ActAccessTable")!
  const _component_ActAccessModal = _resolveComponent("ActAccessModal")!
  const _component_SuccessMessage = _resolveComponent("SuccessMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ButtonGoToUsersActions",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToUserActionsPage && _ctx.navigateToUserActionsPage(...args)))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "lnr-arrow-left NavigationBackButtonIcon" }, null, -1 /* CACHED */),
      _createTextVNode(" Return ", -1 /* CACHED */)
    ]))]),
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "UsersManagementTitle" }, " Manage ACT Access ", -1 /* CACHED */)),
    _createVNode(_component_ActAccessTable),
    (_ctx.isActAccessModalActive)
      ? (_openBlock(), _createBlock(_component_ActAccessModal, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_SuccessMessage)
  ]))
}